module.exports = __webpack_public_path__ + "img/tylenol_pm_caplets.eacd5bf1.jpg";